// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"Error_errorContainer__3X3dt"};